import React, { Component } from 'react';
import SectionHeader from '../../components/views/SectionHeader';
import SectionFooter from '../../components/views/SectionFooter';
import InputField from '../../components/inputs/inputField';
import ToggleField from '../../components/inputs/toggleField';
import moment from 'moment';
import TabsContainer from '../../components/views/TabsContainer';
import TimeField from '../../components/inputs/timeField';
import FieldModal from '../../components/modals/fieldModal';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import VenuesLocationField from '../../components/venues/venuesLocationField';

import BookedSpots from './bookedSpots';

const localizer = momentLocalizer(moment);


const tabs = [
	{ id: 'setup', title: 'Setup' },
	{ id: 'availability', title: 'Availability' },
	{ id: 'requests', title: 'Requests' },
	{ id: 'bookedSpots', title: 'Booked Spots' },
	{ id: 'schedule', title: 'Schedule' }
];

const daysOfWeek = [
	{ id: 'monday', name: 'Monday', short: 'Mon' },
	{ id: 'tuesday', name: 'Tuesday', short: 'Tue' },
	{ id: 'wednesday', name: 'Wednesday', short: 'Wed' },
	{ id: 'thursday', name: 'Thursday', short: 'Thu' },
	{ id: 'friday', name: 'Friday', short: 'Fri' },
	{ id: 'saturday', name: 'Saturday', short: 'Sat' },
	{ id: 'sunday', name: 'Sunday', short: 'Sun' }
];
class CalendarDetail extends Component {
	constructor(props) {
		super(props);

		const calendar = props.calendar || {};
		this.state = {
			editedCalendar: {
				name: calendar.name || '',
				location: calendar.location || '',
				limitSpots: calendar.limitSpots || false,
				maxSpots: calendar.maxSpots || '',
				active: calendar.active || true,
				schedule: calendar.schedule || {},
				startDate: calendar.startDate || moment().format('YYYY-MM-DD'),
				endDate: calendar.endDate || moment().add(30, 'days').format('YYYY-MM-DD'),
			},
			editing: false,
			selectedSection: 'setup',
			scheduleView: 'week', // 'week' or 'day'
			currentWeek: moment().startOf('week'),
			currentDay: moment(),
			calendarView: 'month', // For react-big-calendar
			calendarDate: new Date(), // For react-big-calendar
		};
	}

	handleInputChange = (field, value) => {
		if (field.includes('.')) {
			const parts = field.split('.');
			let editedCalendar = { ...this.state.editedCalendar };
			let current = editedCalendar;

			for (let i = 0; i < parts.length - 1; i++) {
				current[parts[i]] = { ...current[parts[i]] };
				current = current[parts[i]];
			}
			current[parts[parts.length - 1]] = value;

			this.setState({ editedCalendar, editing: true });
		} else {
			this.setState({
				editedCalendar: {
					...this.state.editedCalendar,
					[field]: value
				},
				editing: true
			});
		}
	};

	handleDayToggle = (dayId, isChecked) => {
		const { editedCalendar } = this.state;
		const schedule = { ...editedCalendar.schedule };
		if (schedule[dayId]) {
			schedule[dayId].available = isChecked;
		} else {
			schedule[dayId] = {
				available: true,
				availableTimeRanges: [{
					startTime: '8:00 AM',
					endTime: '5:00 PM'
				}]
			};
		}
		this.setState({
			editedCalendar: {
				...editedCalendar,
				schedule
			},
			editing: true
		});
	};

	saveCalendar = async () => {
		const calendarToSave = {
			...this.props.calendar,
			...this.state.editedCalendar
		};

		await this.props.saveCalendar(calendarToSave, () => {
			this.setState({ editing: false });
		});
	};

	cancelEdit = () => {
		const calendar = this.props.calendar;
		this.setState({
			editedCalendar: {
				name: calendar.name || '',
				location: calendar.location || '',
				limitSpots: calendar.limitSpots || false,
				maxSpots: calendar.maxSpots || '',
				active: calendar.active || true,
				schedule: calendar.schedule || {},
				startDate: calendar.startDate || moment().format('YYYY-MM-DD'),
				endDate: calendar.endDate || moment().add(30, 'days').format('YYYY-MM-DD'),
			},
			editing: false
		});
	};

	handleScheduleChange = (dayId, field, value, rangeIndex = null) => {
		const { editedCalendar } = this.state;
		const schedule = { ...editedCalendar.schedule };

		if (!schedule[dayId]) {
			schedule[dayId] = { available: true };
		}

		if (rangeIndex !== null) {
			// Handle multiple time ranges
			if (!schedule[dayId].availableTimeRanges) {
				schedule[dayId].availableTimeRanges = [];
			}
			const ranges = [...schedule[dayId].availableTimeRanges];
			if (ranges[rangeIndex]) {
				ranges[rangeIndex] = { ...ranges[rangeIndex], [field]: value };
				
				if (field === 'startTime') {
					const startMoment = moment(value, 'h:mm A');
					const endMoment = moment(ranges[rangeIndex].endTime, 'h:mm A');
					if (endMoment.isSameOrBefore(startMoment)) {
						ranges[rangeIndex].endTime = startMoment.add(30, 'minutes').format('h:mm A');
					}
				}
			}
			schedule[dayId].availableTimeRanges = ranges;
		}

		this.setState({
			editedCalendar: { ...editedCalendar, schedule },
			editing: true
		});
	};

	copyDaySchedule = (sourceDayId) => {
		const { editedCalendar } = this.state;
		const schedule = { ...editedCalendar.schedule };
		const sourceSchedule = schedule[sourceDayId];

		if (!sourceSchedule || !sourceSchedule.available) return;

		// Copy to all other days that are currently available
		daysOfWeek.forEach(day => {
			if (day.id !== sourceDayId && schedule[day.id]?.available) {
				schedule[day.id] = {
					...schedule[day.id],
					startTime: sourceSchedule.startTime,
					endTime: sourceSchedule.endTime,
					availableTimeRanges: sourceSchedule.availableTimeRanges ?
						sourceSchedule.availableTimeRanges.map(range => ({ ...range })) : undefined
				};
			}
		});

		this.setState({
			editedCalendar: { ...editedCalendar, schedule },
			editing: true
		});
	};

	removeTimeRange = (dayId, rangeIndex) => {
		const { editedCalendar } = this.state;
		const schedule = { ...editedCalendar.schedule };

		if (schedule[dayId] && schedule[dayId].availableTimeRanges) {
			const ranges = [...schedule[dayId].availableTimeRanges];
			ranges.splice(rangeIndex, 1);
			schedule[dayId].availableTimeRanges = ranges;

			this.setState({
				editedCalendar: { ...editedCalendar, schedule },
				editing: true
			});
		}
	};

	updateSelected = (_index, id) => {
		this.setState({ selectedSection: id });
	};

	// Schedule view methods
	setScheduleView = (view) => {
		this.setState({ scheduleView: view });
	};

	getRequestedTimesForDate = (date) => {
		const { bookingPage } = this.props;
		const { calendar } = this.props;
		const dateStr = date.format('YYYY-MM-DD');

		if (!bookingPage?.requests) return [];

		const requestedTimes = [];
		bookingPage.requests.forEach(request => {
			if (request.selectedDateTimes?.[dateStr]?.[calendar._id]) {
				request.selectedDateTimes[dateStr][calendar._id].forEach(timeSlot => {
					requestedTimes.push({
						time: timeSlot,
						customerName: request.submission?.formData?.firstName && request.submission?.formData?.lastName
							? `${request.submission.formData.firstName} ${request.submission.formData.lastName}`
							: request.submission?.formData?.firstName || 'Unknown Customer',
						customerEmail: request.submission?.formData?.email || '',
						status: this.getRequestStatus(request, dateStr, timeSlot)
					});
				});
			}
		});

		return requestedTimes;
	};

	getRequestStatus = (request, date, timeSlot) => {
		const { calendar } = this.props;
		const calendarId = calendar._id;

		if (request.approvedTimes?.[date]?.[calendarId]?.includes(timeSlot)) {
			return 'approved';
		}
		if (request.deniedTimes?.[date]?.[calendarId]?.includes(timeSlot)) {
			return 'denied';
		}
		return 'pending';
	};

	getBookedTimesForDate = (date) => {
		const { calendar } = this.props;
		const dateStr = date.format('YYYY-MM-DD');

		if (!calendar.bookedSpots) return [];

		return calendar.bookedSpots
			.filter(spot => spot.date === dateStr)
			.map(spot => ({
				time: spot.time,
				timeSlot: spot.timeSlot,
				user: spot.user
			}));
	};

	isTimeAvailable = (date, time) => {
		const { editedCalendar } = this.state;
		const dayOfWeek = date.format('dddd').toLowerCase();
		const schedule = editedCalendar.schedule;

		if (!schedule?.[dayOfWeek]?.available) return false;

		const timeRanges = schedule[dayOfWeek].availableTimeRanges || [];
		const timeMoment = moment(`${date.format('YYYY-MM-DD')} ${time}`, 'YYYY-MM-DD h:mm A');

		return timeRanges.some(range => {
			const startTime = moment(`${date.format('YYYY-MM-DD')} ${range.startTime}`, 'YYYY-MM-DD h:mm A');
			const endTime = moment(`${date.format('YYYY-MM-DD')} ${range.endTime}`, 'YYYY-MM-DD h:mm A');
			return timeMoment.isBetween(startTime, endTime, null, '[)');
		});
	};

	generateTimeSlots = (date) => {
		const { editedCalendar } = this.state;
		const { bookingPage } = this.props;
		const dayOfWeek = date.format('dddd').toLowerCase();
		const schedule = editedCalendar.schedule;

		if (!schedule?.[dayOfWeek]?.available) return [];

		const timeSlots = [];
		const timeRanges = schedule[dayOfWeek].availableTimeRanges || [];
		const duration = bookingPage?.meetingDuration || 30;
		const durationUnit = bookingPage?.durationUnit || 'minutes';

		timeRanges.forEach(range => {
			const startTime = moment(`${date.format('YYYY-MM-DD')} ${range.startTime}`, 'YYYY-MM-DD h:mm A');
			const endTime = moment(`${date.format('YYYY-MM-DD')} ${range.endTime}`, 'YYYY-MM-DD h:mm A');

			let currentTime = startTime.clone();
			while (currentTime.isBefore(endTime)) {
				timeSlots.push(currentTime.format('h:mm A'));
				currentTime.add(duration, durationUnit);
			}
		});

		return timeSlots;
	};

	// Calendar event methods for react-big-calendar
	getCalendarEvents = () => {
		const { calendar, bookingPage } = this.props;
		const events = [];
		const { editedCalendar } = this.state;
		const duration = bookingPage?.meetingDuration || 30;
		const durationUnit = bookingPage?.durationUnit || 'minutes';

		// Simple object to track processed time slots and their events
		const timeSlotEvents = {};
		// NEW: Group multiple bookings by time slot
		const bookedSpotsByTimeSlot = {};

		// Add booked appointments first (highest priority)
		if (calendar.bookedSpots) {
			calendar.bookedSpots.forEach(spot => {
				const key = `${spot.date}-${spot.time}`;
				if (!spot.status || spot.status === 'canceled') {
					return;
				}

				if (!bookedSpotsByTimeSlot[key]) {
					bookedSpotsByTimeSlot[key] = [];
				}

				const registrant = bookingPage.registrants?.find(reg => reg.user?._id === spot.user);
				const userInfo = registrant?.user;

				bookedSpotsByTimeSlot[key].push({
					spot: spot,
					user: userInfo
				});
			});
		}

		for (const key in bookedSpotsByTimeSlot) {
			const bookings = bookedSpotsByTimeSlot[key];
			const date = bookings[0].spot.date;
			const time = bookings[0].spot.time;

			const startTime = moment(`${date} ${time}`, 'YYYY-MM-DD h:mm A');
			const endTime = startTime.clone().add(duration, durationUnit);
			let title;
			if (bookings.length === 1) {
				const userInfo = bookings[0].user;
				title = userInfo ? `${userInfo.firstName} ${userInfo.lastName || ''}` : 'Unknown';
			} else {
				title = `${bookings.length} Bookings`;
			}

			const event = {
				id: `booked-${date}-${time}`,
				title: title,
				start: startTime.toDate(),
				end: endTime.toDate(),
				type: 'booked',
				resource: {
					type: 'booked',
					bookings: bookings, // NEW: Array of all bookings
					count: bookings.length // NEW: Count for easy access
				}
			};

			timeSlotEvents[key] = event;
			events.push(event);
		}

		// Group pending requests by time slot
		const pendingRequestsByTimeSlot = {};

		if (bookingPage?.requests) {
			bookingPage.requests.forEach(request => {
				Object.keys(request.selectedDateTimes || {}).forEach(dateStr => {
					const calendarTimes = request.selectedDateTimes[dateStr]?.[calendar._id];
					if (calendarTimes && Array.isArray(calendarTimes)) {
						calendarTimes.forEach(timeSlot => {
							const status = this.getRequestStatus(request, dateStr, timeSlot);

							// Only include pending requests (not approved or denied)
							if (status === 'pending') {
								const key = `${dateStr}-${timeSlot}`;

								// Skip if this time slot already has a booked appointment
								if (!timeSlotEvents[key]) {
									if (!pendingRequestsByTimeSlot[key]) {
										pendingRequestsByTimeSlot[key] = [];
									}

									// Check if this request is already in the array for this time slot
									const existingRequest = pendingRequestsByTimeSlot[key].find(r => r.request._id === request._id);
									if (!existingRequest) {
										pendingRequestsByTimeSlot[key].push({
											request,
											customerName: request.submission?.formData?.firstName && request.submission?.formData?.lastName
												? `${request.submission.formData.firstName} ${request.submission.formData.lastName}`
												: request.submission?.formData?.firstName || 'Unknown Customer',
											email: request.submission?.formData?.email || '',
											status
										});
									}
								}
							}
						});
					}
				});
			});
		}

		// Add aggregated pending requests (only for time slots without booked appointments)
		Object.keys(pendingRequestsByTimeSlot).forEach(key => {
			const requests = pendingRequestsByTimeSlot[key];

			// Only add if this time slot doesn't already have an event and has requests
			if (!timeSlotEvents[key] && requests.length > 0) {
				// Fix the key splitting - need to handle the date format properly
				const keyParts = key.split('-');
				// The date is in format YYYY-MM-DD, so we need to rejoin the first 3 parts
				const dateStr = `${keyParts[0]}-${keyParts[1]}-${keyParts[2]}`;
				const timeSlot = keyParts.slice(3).join('-'); // Join remaining parts for time

				const startTime = moment(`${dateStr} ${timeSlot}`, 'YYYY-MM-DD h:mm A');
				const endTime = startTime.clone().add(duration, durationUnit);

				const event = {
					id: `requests-${key}`,
					title: `${requests.length} Request${requests.length > 1 ? 's' : ''}`,
					start: startTime.toDate(),
					end: endTime.toDate(),
					type: 'requests',
					resource: {
						type: 'requests',
						requests: requests,
						dateStr: dateStr,
						timeSlot: timeSlot,
						count: requests.length
					}
				};

				timeSlotEvents[key] = event;
				events.push(event);
			}
		});

		return events;
	};

	eventStyleGetter = (event) => {
		let backgroundColor = '#2b83f1'; // Platform primary color
		let borderColor = '#2b83f1';

		if (event.type === 'booked') {
			backgroundColor = '#2b83f1'; // Platform primary for booked (includes approved requests)
			borderColor = '#2b83f1';
		} else if (event.type === 'requests') {
			backgroundColor = '#999'; // Platform gray for pending requests
			borderColor = '#999';
		}

		return {
			style: {
				backgroundColor,
				borderColor,
				color: 'white',
				border: 'none',
				borderRadius: '4px'
			}
		};
	};

	handleEventSelect = (event) => {

		if (event.type === 'booked') {
			// Show booked appointment details
			this.setState({
				selectedEvent: event,
				showEventModal: true,
				modalType: 'booked'
			});
		} else if (event.type === 'requests') {
			// Show requests management modal
			this.setState({
				selectedEvent: event,
				showEventModal: true,
				modalType: 'requests'
			});
		}
	};

	closeEventModal = () => {
		this.setState({
			selectedEvent: null,
			showEventModal: false,
			modalType: null
		});
	};

	handleApproveRequest = async (request, dateStr, timeSlot) => {
		// Use the same approve function as the Requests tab
		this.approveTimeSlot(request._id, dateStr, this.props.calendar._id, timeSlot);
	};

	handleDenyRequest = async (request, dateStr, timeSlot) => {
		// Use the same deny function as the Requests tab
		this.denyTimeSlot(request._id, dateStr, this.props.calendar._id, timeSlot);
	};

	// Check if a registrant has conflicting bookings at the same time
	hasRegistrantConflict = (requestUserId, date, timeSlot) => {
		const { bookingPage } = this.props;

		if (!bookingPage?.requests || !requestUserId) return false;

		// Find all approved bookings for this registrant at the same date/time
		return bookingPage.requests.some(request => {
			if (request.userId !== requestUserId) return false;

			// Check if this registrant has any approved bookings at the same time
			if (request.approvedTimes && request.approvedTimes[date]) {
				return Object.keys(request.approvedTimes[date]).some(calId => {
					return request.approvedTimes[date][calId].includes(timeSlot);
				});
			}

			return false;
		});
	};

	// Methods for the Requests tab
	approveTimeSlot = (requestId, date, calendarId, timeSlot) => {

		// Find the request to get the userId
		const { bookingPage } = this.props;
		const request = bookingPage?.requests?.find(r => r._id === requestId);

		if (request && request.userId) {
			// Check for registrant conflicts
			const hasConflict = this.hasRegistrantConflict(request.userId, date, timeSlot);

			if (hasConflict) {
				alert('Cannot approve: This registrant already has an approved booking at this time.');
				return;
			}
		}

		// Call the parent function to update the main state and make API call
		if (this.props.onApproveTimeSlot) {
			this.props.onApproveTimeSlot(requestId, date, calendarId, timeSlot);
		}

		// Force re-render by updating a dummy state to refresh the calendar events
		this.forceUpdate();
	};

	denyTimeSlot = (requestId, date, calendarId, timeSlot) => {

		// Call the parent function to update the main state and make API call
		if (this.props.onDenyTimeSlot) {
			this.props.onDenyTimeSlot(requestId, date, calendarId, timeSlot);
		}

		// Force re-render by updating a dummy state to refresh the calendar events
		this.forceUpdate();
	};

	isTimeSlotBooked = (calendarId, date, timeSlot) => {
		const { calendar } = this.props;
		if (!calendar?.bookedSpots) return false;

		// Check if this time slot is already booked
		return calendar.bookedSpots.some(booking =>
			booking.date === date && booking.time === timeSlot
		);
	};

	renderRequests = () => {
		const { calendar, bookingPage } = this.props;

		if (!bookingPage?.requests) {
			return (
				<div className="sectionBody pt-0">
					<div className="sectionBlock">
						<h2 className="blockHeader">Requests for {calendar.name}</h2>
						<p>No requests available for this calendar.</p>
					</div>
				</div>
			);
		}

		// Filter requests that have time slots for this calendar
		const calendarRequests = bookingPage.requests.filter(request => {
			return Object.keys(request.selectedDateTimes || {}).some(date => {
				return request.selectedDateTimes[date][calendar._id];
			});
		});

		if (calendarRequests.length === 0) {
			return (
				<div className="sectionBody pt-0">
					<div className="sectionBlock">
						<h2 className="blockHeader">Requests for {calendar.name}</h2>
						<p>No requests available for this calendar.</p>
					</div>
				</div>
			);
		}

		return (
			<div className="sectionBody pt-0">
				<div className="sectionBlock">
					<h2 className="blockHeader">Requests for {calendar.name}</h2>
					<p className="small mb-20">Review and approve/deny individual time slots requested by customers for this calendar.</p>

					{calendarRequests.map(request => {
						const customerName = request.submission?.formData?.firstName && request.submission?.formData?.lastName
							? `${request.submission.formData.firstName} ${request.submission.formData.lastName}`
							: request.submission?.formData?.firstName || 'Unknown Customer';

						return (
							<div key={request._id} className="card p-20 mb-20">
								<h3 className="mb-0">{customerName}</h3>
								<p className="gray small mb-15">{request.submission?.formData?.email}</p>

								{Object.keys(request.selectedDateTimes || {}).map(date => {
									const timeSlots = request.selectedDateTimes[date][calendar._id];
									if (!timeSlots) return null;

									return (
										<div key={date} className="mb-20">
											<h4 className="mb-10">{moment(date).format("dddd, MMMM Do, YYYY")}</h4>

											<div className="flex column gap10">
												{timeSlots.map((timeSlot, index) => {
													const isBooked = this.isTimeSlotBooked(calendar._id, date, timeSlot);
													const wasDenied = request.deniedTimes?.[date]?.[calendar._id]?.includes(timeSlot);
													const wasApproved = request.approvedTimes?.[date]?.[calendar._id]?.includes(timeSlot);
													const hasRegistrantConflict = request.userId ? this.hasRegistrantConflict(request.userId, date, timeSlot) : false;
													const available = !isBooked && !wasApproved && !wasDenied && !hasRegistrantConflict;
													const endTime = moment(`${date} ${timeSlot}`, 'YYYY-MM-DD h:mm A').add(bookingPage.meetingDuration, bookingPage.durationUnit).format("h:mm A");

													return (
														<div key={index} className={`bookingRequestSlot ${!available ? 'disabled' : 'available'} ${wasDenied ? 'denied' : ''} ${wasApproved ? 'approved' : ''} ${hasRegistrantConflict ? 'conflict' : ''}`}>
															<div className="flex aic jcsb">
																<div className="flex aic gap10">
																	<strong>{timeSlot} - {endTime}</strong>
																</div>

																{available && (
																	<div className="flex aic gap10">
																		<button
																			className="icon prim p-7"
																			disabled={isBooked || hasRegistrantConflict}
																			onClick={() => this.approveTimeSlot(request._id, date, calendar._id, timeSlot)}
																		>
																			<i className="las la-check" />
																		</button>
																		<button
																			className="icon danger p-7"
																			onClick={() => this.denyTimeSlot(request._id, date, calendar._id, timeSlot)}
																		>
																			<i className="las la-times" />
																		</button>
																	</div>
																)}
																{wasApproved && <span className="text-success"><i className="las la-check-circle" /> Approved</span>}
																{wasDenied && <span className="text-danger"><i className="las la-times-circle" /> Denied</span>}
																{isBooked && !wasApproved && <span className="text-warning"><i className="las la-exclamation-triangle" /> Time Slot Booked</span>}
																{hasRegistrantConflict && !wasApproved && !wasDenied && <span className="text-warning"><i className="las la-user-times" /> Registrant Conflict</span>}
															</div>
														</div>
													);
												})}
											</div>
										</div>
									);
								})}
							</div>
						);
					})}
				</div>
			</div>
		);
	};

	renderEventModal = () => {
		const { selectedEvent, showEventModal, modalType } = this.state;

		if (!showEventModal || !selectedEvent) return null;

		const modalTitle = modalType === 'booked' ? 'Approved Booking' : 'Pending Requests';

		return (
			<FieldModal
				size="medium"
				isOpen={showEventModal}
				modalTitle={modalTitle}
				bodyHeaderText=""
				bodyDescription=""
				bodyContent={() => {
					return (
						<div className="sectionContainer">
							<div className="sectionBody">
								{modalType === 'booked' && (
									<div>
										<h3 className="mb-20">
											{selectedEvent.resource.count > 1 ?
												`${selectedEvent.resource.count} Bookings` :
												'Booking Details'
											}
										</h3>

										{selectedEvent.resource.count === 1 ? (
											// Single booking display
											<div className="flex column gap10">
												<div className="flex jcsb">
													<span className="gray">Time:</span>
													<span>{moment(selectedEvent.start).format('MMMM D, YYYY h:mm A')}</span>
												</div>
												<div className="flex jcsb">
													<span className="gray">Duration:</span>
													<span>{moment(selectedEvent.end).diff(moment(selectedEvent.start), 'minutes')} minutes</span>
												</div>
												{selectedEvent.resource.bookings[0].user && (
													<>
														<div className="flex jcsb">
															<span className="gray">Customer:</span>
															<span>{selectedEvent.resource.bookings[0].user.firstName} {selectedEvent.resource.bookings[0].user.lastName}</span>
														</div>
														<div className="flex jcsb">
															<span className="gray">Email:</span>
															<span>{selectedEvent.resource.bookings[0].user.emailAddress}</span>
														</div>
													</>
												)}
											</div>
										) : (
											// Multiple bookings display
											<div>
												<div className="flex column gap10 mb-20">
													<div className="flex jcsb">
														<span className="gray">Time:</span>
														<span>{moment(selectedEvent.start).format('MMMM D, YYYY h:mm A')}</span>
													</div>
													<div className="flex jcsb">
														<span className="gray">Duration:</span>
														<span>{moment(selectedEvent.end).diff(moment(selectedEvent.start), 'minutes')} minutes</span>
													</div>
												</div>

												<h4 className="mb-15">Customers:</h4>
												<div className="flex column gap15">
													{selectedEvent.resource.bookings.map((booking, index) => (
														<div key={index} className=" mb-15 p-15">
															<div className="flex jcsb aic">
																<div>
																	{booking.user ? (
																		<>
																			<h4 className="mb-5">{booking.user.firstName} {booking.user.lastName}</h4>
																			<p className="gray small">{booking.user.emailAddress}</p>
																		</>
																	) : (
																		<h4 className="mb-5">Unknown User</h4>
																	)}
																</div>
																{booking.spot.bookedAt && (
																	<div className="text-right">
																		<p className="gray small">Booked: {moment(booking.spot.bookedAt).format('MMM D, h:mm A')}</p>
																	</div>
																)}
															</div>
														</div>
													))}
												</div>
											</div>
										)}
									</div>
								)}

								{modalType === 'requests' && (
									<div>
										<h3 className="mb-10">Manage Requests</h3>
										<p className="gray mb-20">
											{moment(selectedEvent.start).format('MMMM D, YYYY h:mm A')} -
											{selectedEvent.resource.count} pending request{selectedEvent.resource.count > 1 ? 's' : ''}
										</p>

										<div className="flex column gap15">
											{selectedEvent.resource.requests.map((requestData, index) => (
												<div key={index} className="neuCard p-15">
													<div className="flex jcsb aic mb-10">
														<div>
															<h4 className="mb-5">{requestData.customerName}</h4>
															<p className="gray small">{requestData.email}</p>
														</div>
														<div className="flex gap10">
															<button
																className="actionButton prim"
																onClick={() => this.handleApproveRequest(
																	requestData.request,
																	selectedEvent.resource.dateStr,
																	selectedEvent.resource.timeSlot
																)}
															>
																Approve
															</button>
															<button
																className="actionButton danger"
																onClick={() => this.handleDenyRequest(
																	requestData.request,
																	selectedEvent.resource.dateStr,
																	selectedEvent.resource.timeSlot
																)}
															>
																Deny
															</button>
														</div>
													</div>
												</div>
											))}
										</div>
									</div>
								)}
							</div>
						</div>
					);
				}}
				cancelButtonLabel="Close"
				toggle={this.closeEventModal}
			/>
		);
	};

	renderBookedSpots = () => {
		const { calendar, bookingPage } = this.props;
		const bookedDates = {};
		calendar.bookedSpots?.forEach(spot => {
			if (!bookedDates[spot.date]) {
				bookedDates[spot.date] = [];
			}
			bookedDates[spot.date].push(spot);
		});

		Object.keys(bookedDates).forEach(date => {
			bookedDates[date].sort((a, b) => moment(`${date} ${a.time}`, 'YYYY-MM-DD h:mm A').diff(moment(`${date} ${b.time}`, 'YYYY-MM-DD h:mm A')));
		});

		return (
			<div className="sectionBody pt-0">
				<div className="sectionBlock">
					<h2 className="blockHeader">Booked Spots</h2>
					<p className="small mb-20">View all confirmed bookings for this calendar with registrant details.</p>{Object.keys(bookedDates).length === 0 ? (
						<p>No booked spots available.</p>
					) : (
						Object.keys(bookedDates).map(date => (
							<div key={date} className="mb-20">
								<h3 className="mb-15">{moment(date).format('dddd, MMMM D, YYYY')}</h3>
								<div className='flex column gap10'>
									{bookedDates[date].map((spot, index) => {
										const startTime = moment(`${date} ${spot.time}`, 'YYYY-MM-DD h:mm A');
										const endTime = startTime.clone().add(bookingPage?.meetingDuration || 30, bookingPage?.durationUnit || 'minutes');
										const spotRequest = bookingPage?.requests?.find(r => r._id === spot.request);
										const requestRegistrant = bookingPage?.registrants?.find(reg => reg._id === spotRequest?.registrant);
										const regDetails = requestRegistrant ? (requestRegistrant.attendee || requestRegistrant.user) : { firstName: 'Unknown', email: '' };
										return (
											<div key={index} className="neuCard p-15">
												<div className="flex jcsb aic">
													<div className="flex aic gap15">
														<div className="timeSlotInfo">
															<div className="timeSlot">
																<strong>{startTime.format('h:mm A')} - {endTime.format('h:mm A')}</strong>
															</div>
															<div className="duration text-sm gray">
																{bookingPage?.meetingDuration || 30} {bookingPage?.durationUnit || 'minutes'}
															</div>
														</div>
													</div>

													<div className="bookingMeta text-right">

														{regDetails && (
															<div className="registrantInfo">
																<div className="registrantName">
																	<strong>{regDetails.firstName} {regDetails.lastName || ''}</strong>
																</div>
															</div>
														)}
														{spot.bookedAt && (
															<div className="bookedDate text-sm gray">
																Booked: {moment(spot.bookedAt).format('MMM D, h:mm A')}
															</div>
														)}
													</div>
												</div>

												{/* Additional registrant details if available */}
												{spot.additionalInfo && (
													<div className="additionalInfo mt-10 pt-10 border-top">
														<div className="text-sm gray">Additional Information:</div>
														<div className="text-sm">{spot.additionalInfo}</div>
													</div>
												)}
											</div>
										);
									})}
								</div>
							</div>
						))
					)}				</div>
			</div>
		);
	};

	renderScheduleView = () => {
		const events = this.getCalendarEvents();
		const { calendarView, calendarDate } = this.state;

		return (
			<div className="sectionBody pt-0">
				<div className="sectionBlock unset-w mt-20">
					<div style={{ height: 600 }}>
						<Calendar
							localizer={localizer}
							events={events}
							startAccessor="start"
							endAccessor="end"
							views={['month', 'week', 'day']}
							defaultView="week"
							view={calendarView}
							date={calendarDate}
							onView={(view) => this.setState({ calendarView: view })}
							onNavigate={(date) => this.setState({ calendarDate: date })}
							step={30}
							timeslots={2}
							eventPropGetter={this.eventStyleGetter}
							onSelectEvent={this.handleEventSelect}
							onShowMore={(events, date) => {
								this.setState({
									calendarView: 'day',
									calendarDate: date
								});
							}}
							popup
							popupOffset={30}
						/>
					</div>

					{/* Legend */}
					<div className="schedule-legend mt-5">
						<div className="flex gap20">
							<div className="legend-item">
								<div style={{ width: 16, height: 16, backgroundColor: '#2b83f1', borderRadius: 4, marginRight: 8 }}></div>
								<span>Approved Bookings</span>
							</div>
							<div className="legend-item">
								<div style={{ width: 16, height: 16, backgroundColor: '#999', borderRadius: 4, marginRight: 8 }}></div>
								<span>Pending Requests</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	render() {
		const { calendar, eventVenue, bookingPage } = this.props;
		const { editedCalendar, editing, selectedSection } = this.state;

		return (
			<div className="sectionContainer">
				<SectionHeader
					title={calendar.name}
					description="Configure availability and time slots for this calendar"
					closeButton={true}
					updatedAt={calendar.updatedAt}
				/>
				<div className="sectionHeaderChildren">
					<TabsContainer
						tabs={tabs}
						updateSelected={this.updateSelected}
						selectedIndex={tabs.findIndex((t) => t.id === selectedSection)}
					/></div>

				{selectedSection === 'setup' && (
					<div className="sectionBody  pt-0">
						{/* Basic Settings */}
						<div className="sectionBlock">
							<h2 className="blockHeader"></h2>
							<ToggleField
								label="Active"
								checked={editedCalendar.active}
								onChange={(e) => this.handleInputChange('active', e.target.checked)}
								icons={false}
								className="card p-10"
							/>
							<h2 className="blockHeader">Basic Information</h2>

							<InputField
								label="Calendar Name"
								value={editedCalendar.name}
								onChange={(e) => this.handleInputChange('name', e.target.value)}
								placeholder="Enter calendar name"
							/>
							{!bookingPage.isPartofEvent ? <InputField
								label="Location"
								value={editedCalendar.location}
								onChange={(e) => this.handleInputChange('location', e.target.value)}
								placeholder="Enter location of meeting, virtual or physical"
							/> : <VenuesLocationField
								selectedVenue={eventVenue}
								orgId={this.props.orgId}
								venueOptions={[]}
								sessionLocationId={editedCalendar.location}
								isLocation={true}
								selectVenue={(venue) => {
									this.setState({
										venue: {
											value: venue._id,
											label: venue.name,
											color: '#000'
										},
										editing: true
									})
								}}
								venuePicked={this.state.venue}
								selectLocation={(location) => {
									const { _id, name } = location;
									this.handleInputChange('location', _id);
								}}
								addNewLocation={this.props.addNewLocation}
								renameLocation={this.props.renameLocation}
								deleteLocation={this.props.deleteLocation}
								event={this.props.event}
							></VenuesLocationField>}










							<ToggleField
								label="Limit Spots"
								checked={editedCalendar.limitSpots}
								onChange={(e) => this.handleInputChange('limitSpots', e.target.checked)}
								icons={false}
							/>
							{editedCalendar.limitSpots && (
								<InputField
									label="Max Spots"
									value={editedCalendar.maxSpots}
									onChange={(e) => this.handleInputChange('maxSpots', e.target.value)}
									type="number"
									min={1}
									placeholder="Enter max spots"
								/>
							)}

						</div>

					</div>)}

				{selectedSection === 'availability' && (
					<div className="sectionBody pt-0">
						{/* Availability Settings */}

						{/* Working Hours */}
						<div className="sectionBlock">
							<h2 className="blockHeader">Date Range</h2>

							<div className="flex flex-ac gap-20">
								<InputField
									label="Start Date"
									type="date"
									value={editedCalendar.startDate}
									onChange={(e) => this.handleInputChange('startDate', e.target.value)}
									classes="mr-10"
									inputIcon={<i className="las la-calendar" />}
								/>
								<InputField
									label="End Date"
									type="date"
									value={editedCalendar.endDate}
									onChange={(e) => this.handleInputChange('endDate', e.target.value)}
									min={editedCalendar.startDate}
									inputIcon={<i className="las la-calendar" />}
								/>
							</div>

							<h2 className="blockHeader">Schedule</h2>
							<div className="formField">
								<div className="flex column gap10">
									{daysOfWeek.map(day => (<div className='flex gap20' key={day.index}>
										<ToggleField
											label={day.name}
											checked={editedCalendar.schedule?.[day.id]?.available}
											onChange={(e) => this.handleDayToggle(day.id, e.target.checked)}
											className="m-0"
											style={{ width: 200, minWidth: 200, paddingTop: 5 }}
											icons={false}
										/>
										<div className="flex gap10 w-100">
											{editedCalendar.schedule?.[day.id]?.available && (editedCalendar.schedule?.[day.id]?.availableTimeRanges?.length > 0 ? <div className='flex column w-100 gap10'>{editedCalendar.schedule?.[day.id]?.availableTimeRanges.map((range, index) => (
												<div key={index} className="flex aic gap10 posRel">
													<TimeField
														value={range.startTime}
														onChange={(value) => this.handleScheduleChange(day.id, 'startTime', value, index)}
														minTime={index > 0 ? editedCalendar.schedule?.[day.id]?.availableTimeRanges[index - 1].endTime : null}
														classes="m-0"
													/>
													<div>
														<span className="timeRangeSeparator">-</span>
													</div>
													<TimeField
														value={range.endTime}
														onChange={(value) => this.handleScheduleChange(day.id, 'endTime', value, index)}
														minTime={range.startTime}
														classes="m-0"
													/>
													{index > 0 && <button
														style={{ right: -53, top: 5 }}
														className='icon w30 text-danger posAbs'
														onClick={() => this.removeTimeRange(day.id, index)}
														title="Remove time range"
													>
														<i className='las la-trash'></i>
													</button>}
												</div>
											))}</div> : (
												<div className="flex aic gap10 w-100">
													<TimeField
														value={editedCalendar.schedule?.[day.id]?.availableTimeRanges[0]?.startTime}
														onChange={(value) => this.handleScheduleChange(day.id, 'startTime', value, 0)}
														classes="m-0"
													/>
													<div>
														<span className="timeRangeSeparator">-</span>
													</div>
													<TimeField
														value={editedCalendar.schedule?.[day.id]?.availableTimeRanges[0]?.endTime}
														onChange={(value) => this.handleScheduleChange(day.id, 'endTime', value, 0)}
														minTime={editedCalendar.schedule?.[day.id]?.availableTimeRanges[0]?.startTime}
														classes="m-0"
													/>
												</div>))}
										</div>
										{
											editedCalendar.schedule?.[day.id]?.available && <div className='flex aic gap10' style={{ height: 'min-content', paddingTop: 5 }}>
												<button className='icon w30'
													onClick={() => {
														const schedule = { ...editedCalendar.schedule };
														if (!schedule[day.id].availableTimeRanges) {
															schedule[day.id].availableTimeRanges = [{ startTime: '8:00 AM', endTime: '5:00 PM' }];
														}
														schedule[day.id].availableTimeRanges.push({ startTime: '8:00 AM', endTime: '5:00 PM' });
														this.setState({ editedCalendar: { ...editedCalendar, schedule }, editing: true });
													}}
												>
													<i className='las la-plus'></i>
												</button>
												<button
													className='icon w30'
													onClick={() => this.copyDaySchedule(day.id)}
													title="Copy this schedule to all other enabled days"
												>
													<i className='las la-copy'></i>
												</button>
											</div>
										}
									</div>))}
								</div>
							</div>
							<h2 className="blockHeader">
								Date Overrides
							</h2>
							<p className="small mb-20">Add dates when your schedule differs from your regular availability.</p>

							<div className="formField">
								<div className="flex column gap10">
									{(editedCalendar.schedule?.customDates || []).map((customDate, index) => (
										<div key={customDate.date} className="flex aic gap10">
											<InputField
												type="date"
												value={customDate.date}
												onChange={(e) => {
													const newDate = e.target.value;
													editedCalendar.schedule.customDates[index].date = newDate;
													this.setState({ editedCalendar, editing: true });
												}}
												classes="m-0"
											/>
											<TimeField
												value={customDate.availableTimeRanges[0]?.startTime}
												onChange={(value) => {
													const schedule = { ...editedCalendar.schedule };
													if (!schedule.customDates[index].availableTimeRanges) {
														schedule.customDates[index].availableTimeRanges = [];
													}
													schedule.customDates[index].availableTimeRanges[0] = {
														...schedule.customDates[index].availableTimeRanges[0],
														startTime: value
													};
													this.setState({ editedCalendar: { ...editedCalendar, schedule }, editing: true });
												}}
												classes="m-0"
											/>
											<div>
												<span className="timeRangeSeparator">-</span>
											</div>
											<TimeField
												value={customDate.availableTimeRanges[0]?.endTime}
												onChange={(value) => {
													const schedule = { ...editedCalendar.schedule };
													if (!schedule.customDates[index].availableTimeRanges) {
														schedule.customDates[index].availableTimeRanges = [];
													}
													schedule.customDates[index].availableTimeRanges[0] = {
														...schedule.customDates[index].availableTimeRanges[0],
														endTime: value
													};
													this.setState({ editedCalendar: { ...editedCalendar, schedule }, editing: true });
												}}
												minTime={customDate.availableTimeRanges[0]?.startTime}
												classes="m-0"
											/>
											<button
												className='icon w30 text-danger'
												onClick={() => {
													const schedule = { ...editedCalendar.schedule };
													schedule.customDates.splice(index, 1);
													this.setState({ editedCalendar: { ...editedCalendar, schedule }, editing: true });
												}}
											>
												<i className='las la-trash'></i>
											</button>
										</div>
									))}
									<button
										className='icon outline mt-20'
										onClick={() => {
											const schedule = { ...editedCalendar.schedule };
											if (!schedule.customDates) {
												schedule.customDates = [];
											}
											schedule.customDates.push({ available: true, date: moment(editedCalendar.startDate).format('YYYY-MM-DD'), availableTimeRanges: [{ startTime: '8:00 AM', endTime: '5:00 PM' }] })
											this.setState({ editedCalendar: { ...editedCalendar, schedule }, editing: true });
										}}
									>
										<i className='las la-plus'></i>
										Add an Override
									</button>
								</div>
							</div>
						</div>
					</div>)
				}

				{selectedSection === 'bookedSpots' &&

					<BookedSpots
						calendar={calendar}
						bookingPage={this.props.bookingPage}
						cancelBooking={this.props.cancelBooking}
						updateBookedTimeslot={this.props.updateBookedTimeslot}
					/>
				}

				{selectedSection === 'requests' && this.renderRequests()}

				{selectedSection === 'schedule' && this.renderScheduleView()}

				{/* Event Modal */}
				{this.renderEventModal()}

				<SectionFooter
					editing={editing}
					cancelEdit={this.cancelEdit}
					saveEdit={this.saveCalendar}
					updatedAt={calendar.updatedAt}
				/>
			</div >
		);
	}
}

export default CalendarDetail;
